// http://radiosystems.atlassian.net/wiki/spaces/~6328786f07a27ebeff129263/pages/3350331398/Product+Variant+Lifecycle

export const COLLECTION_ACCEPTED_LIFECYCLES = new Set([
  'Available',
  'Coming Soon',
  'Discontinued',
  'Obsolete',
]);

export const filterCollectionProductLifecycle = sanityProduct =>
  COLLECTION_ACCEPTED_LIFECYCLES.has(
    sanityProduct?.store?.productLifecycle ?? ''
  );
